"use client";
import styled, { keyframes } from "styled-components";

const STRIPE_WIDTH = "110px";
const animateButtonPendingBackground = keyframes`
  0% {
		transform: translateX(-${STRIPE_WIDTH});
	}
	100% {
		transform: translateX(0);
	}
`;

export const TransactionFee = styled.div`
  color: var(--text-secondary);
  letter-spacing: 0.5px;
  font-size: 12px;
  line-height: 16px;
  text-align: center;
`;

export const PendingBlock = styled.div`
  width: 100%;
  height: 476px;
  border-radius: var(--rounding-radius-xxl, 32px);
  overflow: hidden;
  position: relative;
  &:after {
    content: " ";
    position: absolute;
    background: repeating-linear-gradient(
      -45deg,
      var(--background-secondary) 25%,
      var(--background-secondary) 50%,
      var(--background-elevated) 50%,
      var(--background-elevated) 75%
    );
    width: calc(100% + ${STRIPE_WIDTH});
    height: 100%;
    background-size: ${STRIPE_WIDTH} ${STRIPE_WIDTH};
    animation: ${animateButtonPendingBackground} 1.5s linear infinite;
    z-index: 8;
  }
`;
